import { useMemo, useState } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

import ImageType from '../types/ImageType'
import Arrow from './Arrow'
import Slide from './Slide'
import usePrevious from 'common/utils/usePrevious'
import { BlockSectionTitle, BlockWrapper, Container } from 'common/widgets'
import classNames from './styles.module.scss'


PortfolioCarousel.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      image: ImageType,
      heading: PropTypes.string,
      subheading: PropTypes.string,
      text: PropTypes.string,
      cta: PropTypes.string,
      cta_link: PropTypes.string,
    })),
  }),
  priorityLoad: PropTypes.bool,
}

export default function PortfolioCarousel({
  data = {
    items: [],
  },
  priorityLoad = false,
}) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const prevIndex = usePrevious(currentIndex)
  const settings = useMemo(() => ({
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    nextArrow: <Arrow position="right" />,
    prevArrow: <Arrow position="left" />,
    afterChange: setCurrentIndex,
  }), [])
  const slides = useMemo(() => get(data, 'items', []).map((option, index) => (
    <Slide
      key={option.heading}
      {...option}
      wasSwiped={index === prevIndex && prevIndex !== currentIndex}
      priority={priorityLoad && index < 2}
    />
  )), [data?.items, prevIndex, currentIndex])

  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <Slider {...settings} className={classNames.slider}>
          {slides}
        </Slider>
      </Container>
    </BlockWrapper>
  )
}
